import { Feeling, LiveVideo, Photo } from "../../svg";
import { useNavigate } from "react-router-dom";
import "./style.css";

export default function CreatePost({ user, setVisible, profile }) {
  const navigate = useNavigate();

  return (
    <div className="createPost">
      <div className="createPost_header">
        <img src={user?.picture} alt="" />
        <div
          className="open_post hover2"
          onClick={() => {
            setVisible(true);
          }}
        >
          What's on your mind, {user?.first_name}
        </div>
      </div>
      <div className="create_splitter"></div>
      <div className="createPost_body">
        <div className="createPost_icon hover1">
          <LiveVideo color="#f3425f" />
          Live Video
        </div>
        <div className="createPost_icon hover1">
          <Photo color="#4bbf67" />
          Photo/Video
        </div>
        {profile ? (
          <div className="createPost_icon hover1">
            <i className="lifeEvent_icon"></i>
            Life Event
          </div>
        ) : (
          <div className="createPost_icon hover1">
            <Feeling color="#f7b928" />
            Feeling/Activity
          </div>
        )}
        <div 
          className="createPost_icon hover1"
          onClick={() => navigate("/portfolio", { state: { openCreateForm: true } })}
          title="Criar um novo projeto no portfolio"
        >
          <span style={{ fontSize: "20px" }}>🎨</span>
          Portfolio
        </div>
      </div>
    </div>
  );
}
